// extracted by css-extract-rspack-plugin
export default {"pagination":"G3fF_"};